import "./ConfirmVerification.html";
import "./ConfirmVerification.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import ConfirmVerificationComponentController from "./ConfirmVerificationComponentController";

export class ConfirmVerificationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = ConfirmVerificationComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/UserVerification/Confirm/ConfirmVerification.html";
    }
}
